import {
  each,
  eachL,
  equals2,
  filter,
  go,
  isNil,
  mapL,
  rangeL,
  rejectL,
} from "fxjs/es";
import { CommonNS } from "../../../../Common/CommonNS.js";
import { SelectionNS } from "../../../../Selection/SelectionNS.js";
import { TransformNS } from "../../../../Transform/TransformNS.js";
import { DATA_KEY_IS_GROUP } from "./const.js";
export class Grouping {
  constructor({
    svg_el,
    SVGElement,
    SVGGraphicsElement,
    transform_manipulator,
    selection,
    scale_transform,
    parent_el,
    createSVGGElement,
  }) {
    this._svg_el = svg_el;
    this._SVGElement = SVGElement;
    this._SVGGraphicsElement = SVGGraphicsElement;
    this._transform_manipulator = transform_manipulator;
    this._selection = selection;
    this._scale_transform = scale_transform;
    this._parent_el = parent_el;
    this._createSVGGElement = createSVGGElement;
  }
  getIsGroup(a) {
    return (
      a instanceof this._SVGElement &&
      equals2(a.dataset[DATA_KEY_IS_GROUP])("true")
    );
  }
  group(els) {
    if (els.length < 2) {
      throw new Error(`2개 이상의 엘리먼트가 필요합니다.`);
    }
    const child_els = this._getChildEls();
    go(
      els,
      eachL((el) => {
        if (!child_els.has(el)) {
          throw new Error(
            `parent 엘리먼트의 자식 엘리먼트만 그룹으로 만들 수 있습니다.`
          );
        }
      }),
      eachL((el) => this._selection.unselectEl(el)),
      each((el) => this._transform_manipulator.initTransform(el))
    );
    const g_el = this._createSVGGElement();
    g_el.dataset[DATA_KEY_IS_GROUP] = "true";
    this._transform_manipulator.initTransform(g_el);
    each((el) => {
      g_el.appendChild(el);
      this._parent_el.dispatchEvent(
        new CustomEvent(`@mp/sticker-editor/remove`, {
          bubbles: true,
          cancelable: true,
          composed: false,
          detail: {
            el,
          },
        })
      );
    })(els);
    this._parent_el.appendChild(g_el);
    this._parent_el.dispatchEvent(
      new CustomEvent(`@mp/sticker-editor/add`, {
        bubbles: true,
        cancelable: true,
        composed: false,
        detail: {
          el: g_el,
        },
      })
    );
    return g_el;
  }
  ungroup(g_el) {
    if (!this.getIsGroup(g_el)) {
      throw new Error(`그룹 엘리먼트가 아닙니다.`);
    }
    if (!this._getChildEls().has(g_el)) {
      throw new Error(
        `parent 엘리먼트의 자식 엘리먼트만 그룹 해제할 수 있습니다.`
      );
    }
    this._selection.unselectEl(g_el);
    const consolidated_transform_matrix =
      CommonNS.UtilNS.getConsolidatedTransformMatrix(g_el) ??
      this._svg_el.createSVGMatrix();
    const is_scaled = this._scale_transform.getIsScaled(g_el);
    const children = g_el.children;
    const ungrouped_els = go(
      rangeL(children.length),
      mapL((i) => children.item(i)),
      filter((el) => el instanceof this._SVGGraphicsElement),
      each((el) => {
        this._parent_el.insertBefore(el, g_el);
        this._parent_el.dispatchEvent(
          new CustomEvent(`@mp/sticker-editor/add`, {
            bubbles: true,
            cancelable: true,
            composed: false,
            detail: {
              el,
            },
          })
        );
        this._transform_manipulator.initTransform(el);
        this._transform_manipulator.setExtendedTransformAfterBase(
          consolidated_transform_matrix,
          el
        );
        is_scaled
          ? this._transform_manipulator.mergeExtendedTransformToFixed(el)
          : this._transform_manipulator.mergeExtendedTransformToBase(el);
      })
    );
    this._parent_el.removeChild(g_el);
    this._parent_el.dispatchEvent(
      new CustomEvent(`@mp/sticker-editor/remove`, {
        bubbles: true,
        cancelable: true,
        composed: false,
        detail: {
          el: g_el,
        },
      })
    );
    return ungrouped_els;
  }
  _getChildEls() {
    const children = this._parent_el.children;
    return new Set(
      go(
        rangeL(children.length),
        mapL((i) => children.item(i)),
        rejectL(isNil)
      )
    );
  }
}
